/*
 * @Author: Teemo Ding
 * @Date: 2022-03-04 16:55:21
 * @LastEditTime: 2022-05-06 14:49:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCommunication/Template/config.tsx
 */
import {
  EditIcon,
  FrontTitle,
} from '@/src/components/EditableTable/EditableTable';
import {
  CommunicationCategory,
  TemplateCondition,
} from '@/src/types/common/template';
import { Form } from 'antd';
import React from 'react';
import { Checkbox } from 'src/components/Antd';
import { TableInput } from 'src/components/EditableTable/TableForm/TableForm';
import { conditions } from 'src/pages/Settings/Communication/CommunicationTemplateDetail/config';
import { CommunicationChannelType } from 'src/types/common/communication';
import css from '../css.module.less';

const FormCheckbox = (props) => {
  const { value, onChange, text } = props;
  const handleChange = (value) => {
    if (value) {
      onChange(text);
    } else {
      onChange();
    }
  };
  return <Checkbox checked={value === text} onChange={handleChange} />;
};

export const conditionsAll = {
  [CommunicationCategory.OrderStatus]: [
    {
      value: TemplateCondition.OrderCancelled,
      name: conditions.OrderCancelled,
    },
    {
      value: TemplateCondition.OrderConfirmed,
      name: conditions.OrderConfirmed,
    },
  ],
  [CommunicationCategory.RefundStatus]: [
    {
      value: TemplateCondition.RefundRejected,
      name: conditions.RefundRejected,
    },
    { value: TemplateCondition.Refunded, name: conditions.Refunded },
  ],
  [CommunicationCategory.ReturnStatus]: [
    {
      value: TemplateCondition.ReturnApproved,
      name: conditions.ReturnApproved,
    },
    {
      value: TemplateCondition.ReturnRejected,
      name: conditions.ReturnRejected,
    },
  ],
  [CommunicationCategory.LogisticsStatusUpdate]: [
    {
      value: TemplateCondition.ParcelDelivering,
      name: conditions.ParcelDelivering,
    },
    {
      value: TemplateCondition.ParcelDelivered,
      name: conditions.ParcelDelivered,
    },
    {
      value: TemplateCondition.ParcelCollected,
      name: conditions.ParcelCollected,
    },
    {
      value: TemplateCondition.ReadyToCollect,
      name: conditions.ReadyToCollect,
    },
  ],
};
export const templateInformationColumns = (
  sendTestFun,
  defaultLanguageName,
  channelType,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelCommunication.index.templateLanguage'),
    dataIndex: 'category',
    key: 'category',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 512,
    render: (_, record) => (
      <div className={css.noCommunication}>{record.description}</div>
    ),
  },
  {
    title: getI18n('salesChannelCommunication.index.setAsDefault'),
    dataIndex: 'channel',
    key: 'channel',
    default: true,
    optional: false,
    className: css.columnClass,
    minWidth: 384,
    render: (_, record) => (
      <Form.Item noStyle name={defaultLanguageName}>
        <FormCheckbox text={record.languageTag} />
      </Form.Item>
    ),
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'action',
    key: 'action',
    default: true,
    optional: false,
    className: css.columnClass,
    width: 192,
    align: 'center',
    render: (_, record) => (
      <div className={css.action}>
        <span
          className={css.primary}
          onClick={() => sendTestFun(record.languageTag)}>
          {getI18n('salesChannelCommunication.index.sendTest')}{' '}
          {channelType === CommunicationChannelType.Email
            ? getI18n('general.customer.email')
            : getI18n('salesChannelCommunication.index.message')}
        </span>
      </div>
    ),
  },
];

export const miniProgramSubscribeMessageColumns = (
  isCondition,
  defaultLanguageName,
  { getI18n },
) => [
  ...(isCondition
    ? [
        {
          title: getI18n('general.condition'),
          dataIndex: 'condition',
          key: 'condition',
          default: true,
          optional: false,
          className: css.columnClass,
          minWidth: 383,
        },
        {
          title: getI18n('salesChannelCommunication.index.templateKeyword'),
          dataIndex: 'name',
          key: 'name',
          default: true,
          optional: false,
          className: ` ${css.noPaddingColumnClass} ${css.borderLeft}`,
          minWidth: 192,
          render: (text) =>
            (text || []).map((item, index) => (
              <div key={index} className={css.keyword}>
                {item.name}
                {item.code}
              </div>
            )),
        },
        {
          title: (
            <FrontTitle>
              <EditIcon />
              <span>
                {getI18n(
                  'salesChannelCommunication.index.templateKeywordContent',
                )}
              </span>
            </FrontTitle>
          ),
          dataIndex: 'code',
          key: 'code',
          default: true,
          optional: false,
          className: css.noPaddingColumnClass,
          minWidth: 416,
          render: (_, record, index) => {
            return (record.name || []).map((item, kIndex) => (
              <Form.Item
                className={css.keywordContent}
                key={kIndex}
                name={[
                  defaultLanguageName,
                  'contents',
                  index,
                  'content',
                  'params',
                  kIndex,
                ]}>
                <TableInput
                  formProps={{
                    noStyle: true,
                  }}
                />
              </Form.Item>
            ));
          },
        },
      ]
    : [
        {
          title: getI18n('salesChannelCommunication.index.templateKeyword'),
          dataIndex: 'name',
          key: 'name',
          default: true,
          optional: false,
          className: css.columnClass,
          minWidth: 512,
          render: (_, record) => (
            <div>
              {record.name}
              {record.code}
            </div>
          ),
        },
        {
          title: (
            <FrontTitle>
              <EditIcon />
              <span>
                {getI18n(
                  'salesChannelCommunication.index.templateKeywordContent',
                )}
              </span>
            </FrontTitle>
          ),
          dataIndex: 'code',
          key: 'code',
          default: true,
          optional: false,
          className: css.columnClass,
          minWidth: 384,
          render: (_, record, index) => (
            <Form.Item noStyle name={[defaultLanguageName, 'params', index]}>
              <TableInput />
            </Form.Item>
          ),
        },
      ]),
];

export const generalInformationAll = {
  [CommunicationCategory.OrderStatus]:
    'salesChannelCommunication.communicationCategory.orderStatus',
  [CommunicationCategory.PaymentReminder]:
    'salesChannelCommunication.communicationCategory.paymentReminder',
  [CommunicationCategory.AbandonedShoppingCart]:
    'salesChannelCommunication.communicationCategory.abandonedShoppingCart',
  [CommunicationCategory.RefundStatus]:
    'salesChannelCommunication.communicationCategory.refundStatus',
  [CommunicationCategory.ReturnStatus]:
    'salesChannelCommunication.communicationCategory.returnStatus',
  [CommunicationCategory.CreateSubscriptionBuyOrder]:
    'salesChannelCommunication.communicationCategory.createSubscriptionBuyOrder',
  [CommunicationCategory.OrderInvoice]:
    'salesChannelCommunication.communicationCategory.orderInvoice',
  [CommunicationCategory.CreateOrder]:
    'salesChannelCommunication.communicationCategory.createOrder',
  [CommunicationCategory.CreateShoppingCart]:
    'salesChannelCommunication.communicationCategory.createShoppingCart',
  [CommunicationCategory.VirtualProductNotification]:
    'salesChannelCommunication.communicationCategory.virtualProductNotification',
  [CommunicationCategory.GiftCardIssued]:
    'salesChannelCommunication.communicationCategory.giftCardIssued',
  [CommunicationCategory.GiftCardBalanceChanged]:
    'salesChannelCommunication.communicationCategory.giftCardBalanceChanged',
  [CommunicationCategory.StoreCreditIssued]:
    'salesChannelCommunication.communicationCategory.storeCreditIssued',
  [CommunicationCategory.LogisticsStatusUpdate]:
    'salesChannelCommunication.communicationCategory.logisticsStatusUpdate',
  [CommunicationCategory.AccountInvitation]:
    'salesChannelCommunication.communicationCategory.accountInvitation',
  [CommunicationCategory.AccountWelcome]:
    'salesChannelCommunication.communicationCategory.accountWelcome',
  [CommunicationCategory.AccountPasswordReset]:
    'salesChannelCommunication.communicationCategory.accountPasswordReset',
  [CommunicationCategory.VerificationCode]:
    'salesChannelCommunication.communicationCategory.verificationCode',
  [CommunicationCategory.CustomerServiceRequest]:
    'salesChannelCommunication.communicationCategory.customerServiceRequest',
  [CommunicationCategory.RestockItem]:
    'salesChannelCommunication.communicationCategory.restockItem',
  [CommunicationCategory.FlashSaleStart]:
    'salesChannelCommunication.communicationCategory.flashSaleStart',
  [CommunicationCategory.VoucherIssued]:
    'salesChannelCommunication.communicationCategory.voucherIssued',
  [CommunicationCategory.VoucherExpiration]:
    'salesChannelCommunication.communicationCategory.voucherExpiration',
};
